import { Route, Routes } from "react-router-dom";
import NotificationManager from "./NotificationManager";
import EditNotificationTemplate from "./EditNotificationTemplate";

// Single mount point registered in AppRoutes.tsx at
// "/configurations/notification-manager/*".
export default function NotificationManagerApp() {
  return (
    <Routes>
      <Route index element={<NotificationManager />} />
      <Route path="edit/:id" element={<EditNotificationTemplate />} />
    </Routes>
  );
}
